import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import * as Swetrix from 'swetrix';
import { shouldEnableTracking } from '../lib/tracking.js';

const PROJECT_ID = 'LyAKFPhdQ3NZ';
const API_URL = 'https://analytics-api.illumine-studio.com/log';

let initialized = false;

const initSwetrix = () => {
  if (initialized) return;
  Swetrix.init(PROJECT_ID, { apiURL: API_URL });

  // Enable automatic error tracking
  Swetrix.trackErrors({
    sampleRate: 1, // Capture all errors
  });

  initialized = true;
};

export default function SwetrixTracker() {
  const location = useLocation();
  const trackingEnabled = shouldEnableTracking();
  const isFirstRender = useRef(true);

  // Initialize and track first pageview
  useEffect(() => {
    if (!trackingEnabled) return;

    initSwetrix();
    Swetrix.trackViews();
  }, [trackingEnabled]);

  // Track route changes (skip first render since trackViews handles it)
  useEffect(() => {
    if (!trackingEnabled) return;

    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    initSwetrix();
    Swetrix.trackViews({
      callback: () => ({
        pg: `${location.pathname}${location.search}`,
      }),
    });
  }, [location.pathname, location.search, trackingEnabled]);

  return null;
}
